import { RootState } from '../../../../../Redux/Store';
import { useAppSelector } from '../../../../../Hooks/Hooks';
import CustomTable from '../../../CustomTable/CustomTable';
import { TLoadReferencesContainerProps } from './LoadReferencesContainer.type';
import './LoadReferencesContainer.scss';

const LoadReferencesContainer = (props: TLoadReferencesContainerProps) => {
  const { references, modalView } = props;
  const { loadDetails } = useAppSelector((state: RootState) => {
      return state?.myLoads;
    });
  const requestReferenceUrl = loadDetails[0].requestReferenceUrl;

  return (
    <div className="LoadReferencesContainer">
      {
        <CustomTable
          data={references}
          tableColumnTitle={['Reference Type', 'Reference Value']}
          tableLabel={modalView ? '' : 'References Detail'}
          link={requestReferenceUrl}
          additionalClass="Commodities_Details_Link"
          modalView={modalView}
        />
      }
    </div>
  );
};

export default LoadReferencesContainer;
